var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-page"},[_c(_vm.currentComponent.component,{tag:"component",attrs:{"timeFormat":_vm.timeFormat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }